import { usePrivy } from "@privy-io/react-auth"

export const usePrivyUser = () => {
  const { user } = usePrivy()
  return user
}
